<app-header-public [showAuthButtons]="false"></app-header-public>
<div id="registro">
  <div class="container">
    <div class="registro-title-wrap">
      <h2 class="title_component">Formulario de registro
        <span class="type_form">{{ subTitle }}</span>
      </h2>
      <hr class="title_component-line" />
    </div>
  </div>
  <div class="container registro-form-wrap">
    @if (subTitle === 'persona natural') {
      <formulario-persona-natural></formulario-persona-natural>
    }
    @if (subTitle === 'persona jurídica') {
      <formulario-persona-juridica></formulario-persona-juridica>
    }
  </div>
</div>
<app-footer-public [showLogoOnly]="true"></app-footer-public>